import {localeHref} from '../i18n/locale';

export {ScrollToTop} from './ScrollToTop';

export const newsHref = (locale: string, uuid: string): string => localeHref(locale, `/news/${uuid}`);
export const countryHref = (locale: string, uuid: string): string => localeHref(locale, `/countries/${uuid}`);
export const aboutHref = (locale: string): string => localeHref(locale, '/about');
export const projectsHref = (locale: string): string => localeHref(locale, '/projects');
export const projectHref = (locale: string, uuid: string): string => localeHref(locale, `/projects/${uuid}`);
export const phaseHref = (locale: string, uuid: string): string => localeHref(locale, `/phases/${uuid}`);
export const unitHref = (locale: string, uuid: string): string => localeHref(locale, `/unit-types/${uuid}`);

export const newsForProjectHref = (locale: string, projectId: string): string => localeHref(locale, `/news?project=${projectId}`);

export const phasesHref = (locale: string, projectId?: string): string =>
  projectId ? localeHref(locale, `/phases?project=${projectId}`) : localeHref(locale, '/phases');

export const unitTypesHref = (locale: string, filter?: {projectId?: string; phaseId?: string}): string => {
  const params = new URLSearchParams();
  if (filter?.projectId) {
    params.set('project', filter.projectId);
  }
  if (filter?.phaseId) {
    params.set('phase', filter.phaseId);
  }
  const query = params.toString();
  return query ? localeHref(locale, `/unit-types?${query}`) : localeHref(locale, '/unit-types');
};
